import React, { useCallback, useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import ListingContext from 'router/subrouters/ListingCreationWizard/providers/Listing/Listing.context';
import useHeightAnimation from 'hooks/useHeightAnimation';
import useCallbackRef from 'hooks/useCallbackRef';
import { useFormState } from 'react-final-form';

import './CheckoutForm.styles.scss';

type CheckoutFormProps = {
  className?: string;
};

const CheckoutForm: React.FC<CheckoutFormProps> = (props) => {
  const { className } = props;
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();
  const { setPayment } = useContext(ListingContext);
  const [container, containerRef] = useCallbackRef(null);
  const [errMessage, setErrMessage] = useState('');

  const { submitting, invalid } = useFormState();

  const classes = classNames('checkout-form', className);

  useHeightAnimation({ element: container });

  const handlePayment = useCallback(async () => {
    if (!stripe || !elements) return;

    const { error } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    });

    if (error) {
      setErrMessage(error.message);
    }

    return error;
  }, [elements, stripe]);

  useEffect(() => {
    setPayment && setPayment(() => handlePayment);
  }, [setPayment, handlePayment]);

  return (
    <div className={classes} ref={containerRef}>
      <div>
        {errMessage && <p className="payment__error">{errMessage}</p>}
        <PaymentElement />
        <Button type="submit" disabled={submitting || invalid}>
          {t('completePayment')}
        </Button>
      </div>
    </div>
  );
};

export default CheckoutForm;
